import {
  SELECTED_PET_KEY,
  PET_LIST_KEY,
  SPECIES_LIST_KEY,
  RACE_LIST_KEY,
} from '../../types/pets.types'

export default function () {
  return {
    [SELECTED_PET_KEY]: null,
    [PET_LIST_KEY]: null,
    [SPECIES_LIST_KEY]: [],
    [RACE_LIST_KEY]: [],
  }
}
